const SwimSafetyAdminCount = ({
  SwimSafetyDashBoardStore: { SwimSafetyDashboardCount }
}) => SwimSafetyDashboardCount;
export default SwimSafetyAdminCount;

export const SwimSafetyAssocListSelector = ({
  SwimSafetyDashBoardStore: { SwimSafetyAssociationList }
}) => SwimSafetyAssociationList;